import { DetailsList, IconButton, SelectionMode } from '@fluentui/react';
import { PanelType, Stack } from 'office-ui-fabric-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import React, { Component } from 'react';
import { IDS_REGLELEAD } from '../../data/DataRegleLead';
import { DataRepartiteur } from '../../data/DataRepartiteur';
import { IDS_TYPE_MANDAT } from '../../data/DataTypeMandat';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { ComboBoxNiveau, IDS_NIVEAU } from '../ComboBox/ComboBoxNiveau';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion';
import { ComboBoxRegleLead } from '../ComboBox/ComboBoxRegleLead';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUISeparator } from '../EUI/EUISeparator';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheRepartiteur extends Component {

    static defaultProps = {
        idPerimetreLead: undefined,
        isOpen: false,
        mandatNational: true,
        onDismiss: () => null,
        onSave: () => null,
    };

    static defaultState = {
        items: [],
        perimetreLead: {
            idRegion: undefined,
            idAgence: undefined,
            idOperation: undefined,
        },
        /* --- */
        idNiveauSelectionne: undefined,
        idSocieteSelectionnee: undefined,
        loginCompteSelectionne: undefined,
        regleLeadSelectionnee: {
            idRegleLead: IDS_REGLELEAD.UN_POUR_X,
            nom: "1 pour X"
        },
        /* --- */
        onActiveBoutonAjouter: false,
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheRepartiteur.defaultState };
    };

    _ajouterRegle = () => {

        const { items, loginCompteSelectionne, regleLeadSelectionnee } = this.state;
        const { idRegleLead, nom } = regleLeadSelectionnee;
        const { FIXE } = IDS_REGLELEAD;

        if (!!loginCompteSelectionne) {
            let newItems = [];
            if (idRegleLead === FIXE) {
                // Si ajout d'une règle FIXE alors remplacer toutes les autres règles déjà existantes
                newItems = [{ loginCompte: loginCompteSelectionne, idRegleLead, nom }];
            }
            else {
                // Si ajout d'une règle autre que FIXE...
                newItems = items
                    .filter(item => item.idRegleLead !== FIXE) // S'il existe une règle FIXE la supprimer
                    .filter(item => item.loginCompte !== loginCompteSelectionne); // S'il existe déjà une règle associée au loginCompte sélectionné la supprimer
                newItems.push({ loginCompte: loginCompteSelectionne, idRegleLead, nom });
            }
            this.setState({ items: newItems }, this._onVerificationFormulaire);
        }

    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement du règles de répartiteur"
        });

        const { idPerimetreLead } = this.props;

        if (!!idPerimetreLead) { // Mode modification ; au clic sur un crayon de la DetailsListRepartiteur
            const { perimetreLead } = this.state;

            DataRepartiteur._chargementFicheRepartiteur(idPerimetreLead).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const { perimetre, items } = responseFetch.reponseAPIobjet;
                    const { idRegion, idAgence, idOperation } = perimetre[0];

                    const newPerimetreLead = { ...perimetreLead, idRegion, idAgence, idOperation };
                    let state = { perimetreLead: newPerimetreLead, items };

                    if (!idRegion && !idAgence && !idOperation)
                        state.idNiveauSelectionne = IDS_NIVEAU.NATIONAL;
                    else if (!!idRegion && !idAgence && !idOperation)
                        state.idNiveauSelectionne = IDS_NIVEAU.REGION;
                    else if (!!idRegion && !!idAgence && !idOperation)
                        state.idNiveauSelectionne = IDS_NIVEAU.AGENCE;
                    else if (!!idRegion && !!idAgence && !!idOperation)
                        state.idNiveauSelectionne = IDS_NIVEAU.OPERATION;
                    else
                        state.idNiveauSelectionne = undefined;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
        }

        else { // Mode création ; à la sélection d'un périmètre
            const { idNiveauSelectionne, perimetreLead } = this.state;
            const { idRegion, idAgence, idOperation } = perimetreLead;
            const perimetreNational = idNiveauSelectionne === IDS_NIVEAU.NATIONAL;

            DataRepartiteur._chargementFicheRepartiteur(null, idRegion, idAgence, idOperation, perimetreNational).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const { items } = responseFetch.reponseAPIobjet;
                    const state = { items };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);                
            });
        }

    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement en cours",
        });

        const { idPerimetreLead, onSave } = this.props;
        const { items, perimetreLead, idNiveauSelectionne } = this.state;

        DataRepartiteur._onEnregistrementPerimetre_RegleLead_Compte(idPerimetreLead, perimetreLead, idNiveauSelectionne, items).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { ...FicheRepartiteur.defaultState }, onSave);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _estPerimetreCorrectementSelectionne = () => {

        const { idNiveauSelectionne, perimetreLead } = this.state;
        const { idRegion, idAgence, idOperation } = perimetreLead;
        const { NATIONAL, REGION, AGENCE, OPERATION } = IDS_NIVEAU;

        let estPerimetreCorrectementSelectionne = true;

        switch (idNiveauSelectionne) {
            case OPERATION: estPerimetreCorrectementSelectionne &= !!idOperation;
            case AGENCE: estPerimetreCorrectementSelectionne &= !!idAgence;
            case REGION: estPerimetreCorrectementSelectionne &= !!idRegion;
            case NATIONAL: break;
            default: estPerimetreCorrectementSelectionne = false; break;
        }

        return estPerimetreCorrectementSelectionne;

    };

    _onChangeCommercialisateur = (loginCompte) => {
        this.setState({ loginCompteSelectionne: loginCompte }, this._onVerificationFormulaireRegleLead);
    };

    _onChangePerimetre = (key, value) => {
        let perimetreLead = { ...this.state.perimetreLead, [key]: value };
        switch (key) {
            case "idRegion": perimetreLead.idAgence = 0;
            case "idAgence": perimetreLead.idOperation = 0; break;
            default: break;
        }
        this.setState(
            {
                perimetreLead,
                idSocieteSelectionnee: undefined,
                loginCompteSelectionne: undefined,
                items: [],
                onActiveBoutonEnregistrer: false,
            },
            () => this._estPerimetreCorrectementSelectionne() && this._chargementDonnees()
        );
        ;
    };

    _onChangeSociete = (idSociete) => {
        this.setState(
            { idSocieteSelectionnee: idSociete, loginCompteSelectionne: undefined },
            this._onVerificationFormulaireRegleLead
        );
    };

    _onDismiss = () => {
        this.setState({ ...FicheRepartiteur.defaultState });
        this.props.onDismiss();
    };

    _onOpen = () => {
        const { idPerimetreLead } = this.props;
        if (!!idPerimetreLead)
            this._chargementDonnees();
    };

    _onSelectionNiveau = (idNiveau) => {
        let perimetreLead = { ...this.state.perimetreLead };
        switch (idNiveau) {
            case IDS_NIVEAU.NATIONAL:
            case IDS_NIVEAU.REGION: perimetreLead.idRegion = 0;
            case IDS_NIVEAU.AGENCE: perimetreLead.idAgence = 0;
            case IDS_NIVEAU.OPERATION: perimetreLead.idOperation = 0;
            default: break;
        }
        const state = {
            perimetreLead,
            idNiveauSelectionne: idNiveau,
            items: [],
            onActiveBoutonEnregistrer: false,
        };
        this.setState(
            state,
            () => this._estPerimetreCorrectementSelectionne() && this._chargementDonnees()
        );
    };

    _onVerificationFormulaire = () => {
        const { idPerimetreLead } = this.props;
        const { perimetreLead, idNiveauSelectionne, items } = this.state;
        const objet = { ...perimetreLead, idNiveauSelectionne, idPerimetreLead, items };
        Immocom.fiche()._validationFormulaire(this, "Repartiteur", objet, !!idPerimetreLead ? "Modification" : "Création");
    };

    _onVerificationFormulaireRegleLead = () => {

        const { loginCompteSelectionne, regleLeadSelectionnee } = this.state;
        const { idRegleLead } = regleLeadSelectionnee;

        let onActiveBoutonAjouter = true;

        onActiveBoutonAjouter &= !!loginCompteSelectionne;
        onActiveBoutonAjouter &= !!idRegleLead;
        onActiveBoutonAjouter &= this._estPerimetreCorrectementSelectionne();

        this.setState({ onActiveBoutonAjouter })

    };

    _supprimerRegle = (loginCompte) => {
        this.setState(
            (prev) => ({ items: [...prev.items.filter(item => item.loginCompte !== loginCompte)] }),
            this._onVerificationFormulaire
        );
    };

    render = () => {

        const { idPerimetreLead, isOpen, mandatNational } = this.props;
        const { idNiveauSelectionne, idSocieteSelectionnee, items, loginCompteSelectionne, onActiveBoutonAjouter, onActiveBoutonEnregistrer, perimetreLead, regleLeadSelectionnee } = this.state;
        const { idRegleLead } = regleLeadSelectionnee;
        const { NATIONAL, REGION, AGENCE, OPERATION } = IDS_NIVEAU;
        const estPerimetreCorrectementSelectionne = this._estPerimetreCorrectementSelectionne();

        return <EUIPanel
            headerText="Gestion des règles du répartiteur"
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            onSave={this._enregistrer}
            type={PanelType.medium}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <ComboBoxNiveau
                disabled={!!idPerimetreLead}
                inclureLot={false}
                inclureProgramme={false}
                inclureNational={mandatNational}
                onChange={(event, option, index, value, item) => this._onSelectionNiveau(option.key)}
                required
                selectedKey={idNiveauSelectionne}
            />

            <ComboBoxRegion
                disabled={!!idPerimetreLead || !idNiveauSelectionne || [NATIONAL].includes(idNiveauSelectionne)}
                onChange={(event, option, index, value, item) => this._onChangePerimetre("idRegion", option.key)}
                required={[REGION, AGENCE, OPERATION].includes(idNiveauSelectionne)}
                selectedKey={perimetreLead.idRegion}
                filtreSurMonPerimetre
            />

            <ComboBoxAgence
                disabled={!!idPerimetreLead || !idNiveauSelectionne || [NATIONAL, REGION].includes(idNiveauSelectionne)}
                idRegion={perimetreLead.idRegion}
                onChange={(event, option, index, value, item) => this._onChangePerimetre("idAgence", option.key)}
                required={[AGENCE, OPERATION].includes(idNiveauSelectionne)}
                selectedKey={perimetreLead.idAgence}
                filtreSurMonPerimetre
            />

            <ComboBoxOperation
                disabled={!!idPerimetreLead || !idNiveauSelectionne || [NATIONAL, REGION, AGENCE].includes(idNiveauSelectionne)}
                idAgence={perimetreLead.idAgence}
                idRegion={perimetreLead.idRegion}
                onChange={(event, option, index, value, item) => this._onChangePerimetre("idOperation", option.key)}
                perimetre="eiffage"
                required={[OPERATION].includes(idNiveauSelectionne)}
                selectedKey={perimetreLead.idOperation}
                filtreSurMonPerimetre
            />

            <ComboBoxSociete
                avecMandatSurLotDeLOperation
                disabled={!estPerimetreCorrectementSelectionne}
                idAgence={perimetreLead.idAgence}
                idOperation={perimetreLead.idOperation}
                idRegion={perimetreLead.idRegion}
                onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                selectedKey={idSocieteSelectionnee}
            />

            <ComboBoxCompte
                disabled={!idSocieteSelectionnee}
                idSociete={idSocieteSelectionnee}
                idsTypesMandats={idSocieteSelectionnee === 1 ? undefined : [IDS_TYPE_MANDAT.COMMERCIALISATEUR]}
                label="Commercialisateur"
                onChange={(event, option, index, value, item) => this._onChangeCommercialisateur(option.key)}
                selectedKey={loginCompteSelectionne}
            />

            <Stack horizontal verticalAlign="end" gap={8}>
                <Stack.Item grow>
                    <ComboBoxRegleLead
                        disabled={!estPerimetreCorrectementSelectionne}
                        onChange={(event, option, index, value, item) => this.setState({ regleLeadSelectionnee: item }, this._onVerificationFormulaireRegleLead)}
                        selectedKey={idRegleLead}
                    />
                </Stack.Item>
                <PrimaryButton onClick={this._ajouterRegle} disabled={!onActiveBoutonAjouter}>Ajouter</PrimaryButton>
            </Stack>

            <EUISeparator />

            <DetailsList
                columns={[
                    {
                        fieldName: "loginCompte",
                        isResizable: true,
                        key: "loginCompte",
                        name: "Compte",
                    },
                    {
                        isResizable: true,
                        key: "nom",
                        maxWidth: 150,
                        minWidth: 100,
                        name: "Règle",
                        onRender: (item) => {
                            const nom = item.nom;
                            return <span title={nom}>{nom}</span>;
                        }
                    },
                    {
                        key: "delete",
                        name: "Delete",
                        ariaLabel: "Supprimer la règle",
                        minWidth: 20,
                        maxWidth: 20,
                        iconName: "",
                        isIconOnly: true,
                        onRender: (item) => {
                            return <IconButton
                                ariaLabel="Supprimer la règle"
                                iconProps={{ iconName: "Delete" }}
                                onClick={() => this._supprimerRegle(item.loginCompte)}
                                title="Supprimer la règle"
                            />;
                        }
                    }
                ]}
                compact
                items={items}
                selectionMode={SelectionMode.none}
            />

        </EUIPanel>;

    };

};